module.exports = __webpack_public_path__ + "img/henkel-cedis-gdl.79a8aeb5.jpg";